import { get } from 'lodash';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { FeatureToggle } from '@components/common';
import FeatureCheck from '@components/common/FeatureCheck';
import { ContextTrends } from '@src/pages';
import featureNames from '@utils/featureToggle/constants';
import Eco2AiAlertDetail from '../pages/Eco2AiAlertDetail';
import EcoAIAlertSummary from '../pages/Eco2AIAlertSummary';

const Trends = (props) => {
  return (
    <FeatureToggle
      feature={featureNames.ECO_SERVER_ENABLED}
      fallback={<FeatureCheck featureName={'ECO_SERVER_ENABLED'} />}
    >
      <ContextTrends {...props} />
    </FeatureToggle>
  );
};
const ecoServerRenderer = (props) => {
  return <Trends  {...props} />;
};

const Eco2AIAlertSummaryPage = () => <EcoAIAlertSummary />;
const Eco2DetailPage = (props) => (
  <Eco2AiAlertDetail key={get(props, 'match.params.id', -1)} {...props} />
);

const EcoServerRouter = () => {
  const match = useRouteMatch();
  
  return (
    <Switch>
      <Route exact path={`${match.path}/dashboard/ai-alerts`} render={Eco2AIAlertSummaryPage} />
      <Route
        exact
        path={`${match.path}/dashboard/ai-alerts/diagnostics/:id`}
        render={Eco2DetailPage}
      />
      <Route exact path={`${match.path}/dashboard/trends/:context/:alertId`} component={ecoServerRenderer} />
    </Switch>
  );
};

export default EcoServerRouter;
